import {management} from '../../../../index.js' //api
import {VolumeRepository} from "../../../infra/knex/repositories/volume"
import {GetVolumeSinceFirstLogUseCase} from "./getVolumeSinceFirstLog"


export  const getVolumeSinceFirstLogUseCase=new GetVolumeSinceFirstLogUseCase(new VolumeRepository(management))
